import T from 'terrific';
import $ from 'jquery';
import * as toggle from '../../../../assets/js/utils/toggle';

/**
 * Basic Module description.
 */
T.Module.LanguageSwitch = T.createModule({
	_attributes: {
		targetDevice: 'data-js-trigger-target-device',
		languageSwitchIsoCode: 'data-js-language-switch-iso-code',
	},
	_selectors: {
		fancyboxLanguageSwitchConfirmContent: '#language-switch-confirm-content',
		closeBtn: '[data-js-close-btn]',
		acceptBtn: '[data-js-accept-btn]',
		toggleTrigger: '[data-js-language-switch-toggle-trigger]',
		languageSwitchSubmitTrigger: '[data-js-language-switch-submit-trigger]',
		languageSwitchForm: '.data-js-language-switch-form',
		languageSwitchFormIsoCodeField: '[data-js-language-switch-form-iso-code-field]',
	},
	_eventNames: {
		CLICK: 'click',
	},
	_data: {
		// Target selectors of elements to be toggled, so component knows its
		// selectors itself and is not reliant on having them passed as a value.
		targetSelectors: {
			mobile: '[data-js-language-switch-mobile]',
			desktop: '[data-js-language-switch-desktop]',
		},
	},

	// eslint-disable-next-line complexity
	start(resolve) {
		// bind ctx
		this.$ctx = $(this._ctx);
		const $languageForm = this.$ctx.find(this._selectors.languageSwitchForm);
		const $langIsoCode = this._attributes.languageSwitchIsoCode;
		const $languageFormIsoCodeField = this.$ctx.find(this._selectors.languageSwitchFormIsoCodeField);
		this.$ctx.find(this._selectors.toggleTrigger)
			.on(this._eventNames.CLICK, (ev) => {
				this.toggleLanguageSwitch(ev);
			});
		this.$ctx.find(this._selectors.languageSwitchSubmitTrigger)
			.on(this._eventNames.CLICK, (ev) => {
				ev.preventDefault();
				const $el = $(ev.currentTarget);
				const languageIsoCode = $el.attr($langIsoCode);
				$languageFormIsoCodeField.val(languageIsoCode);
				$.fancybox.open({
					src: this._selectors.fancyboxLanguageSwitchConfirmContent,
				});
				$('.fancybox-slide [data-js-close-btn]').bind('click', () => {
					$.fancybox.close();
				});

				$('.fancybox-slide [data-js-accept-btn]').bind('click', () => {
					$languageForm.submit();
				});
			});
		this._events.on('closeActiveToggle', () => {
			// Condition to prevent multiple execution
			if (toggle.isActive(this.$ctx, this._selectors.toggleTrigger)) {
				this.$ctx
					.find(this._selectors.toggleTrigger)
					.trigger(this._eventNames.CLICK);
			}
		});

		// Event gets received by all instances (triggers, targets, mobile|desktop)
		this._events.on('toggableMenuClicked', (targetDevice, sendingTriggerSelector) => {
			toggle.onToggableMenuClicked(
				this.$ctx,
				sendingTriggerSelector,
				this._selectors.toggleTrigger,
				this._data.targetSelectors[targetDevice]
			);
		});

		resolve();
	},

	sync() {
		// Called when start() method of all registered modules was called.
	},

	toggleLanguageSwitch(ev) {
		const $el = $(ev.currentTarget);
		const targetDevice = $el.attr(this._attributes.targetDevice);
		const targetSelector = this._data.targetSelectors[targetDevice];

		this._events.emit('toggableMenuClicked', targetDevice, this._selectors.toggleTrigger);

		toggle.toggleContent($el, targetSelector);

		if (toggle.isActive(this.$ctx, this._selectors.toggleTrigger)) {
			this._events.emit('bindClickToBodyToCloseActiveToggle');
		} else {
			this._events.emit('unBindClickToBodyToCloseActiveToggle');
		}
	},
});
